export enum Duration {
  Millisecond = 1,
  Second = 1000,
  Minute = 60 * 1000,
}

export const wait = (duration: number) => {
  return new Promise((r) => setTimeout(r, duration));
};
